import { gql } from "@apollo/client";

/**
 * Everything CustomerInfoPairBox needs to draw the account this page is
 * about, plus the two relations the actions are gated on.
 *
 * childCustomers is only counted, never listed, so it carries nothing but
 * ids - which is the one thing this asks for that ChildCustomersFragment
 * does not, the rest being the same CustomerBox both have to satisfy.
 */
export const CustomerPriceParentFragment = gql`
  fragment CustomerPriceParent on Customer {
    id
    name
    breadCrumbName
    custIndex
    custNo
    statisticalGrouping {
      id
    }
    invoiceCurrency {
      id
      code
    }
    hasRebateAgreements
    salesRegion {
      id
      name
    }
    seller {
      id
      name
    }
    custStatus {
      id
      name
    }
    writeHistory {
      createdAt {
        isoString
      }
      createdBy {
        name
      }
      modifiedBy {
        name
      }
      modifiedAt {
        isoString
      }
    }
    isParent
    parent {
      id
      preselectedHeadAgreement {
        id
      }
    }
    childCustomers {
      id
    }
    parentHistory {
      parentCustomerNo
      validFrom
      validTo
      parentCustomer {
        id
        custIndex
      }
    }
  }
`;
